import { render, staticRenderFns } from "./KusDemoForm.vue?vue&type=template&id=3764f28f"
import script from "./KusDemoForm.vue?vue&type=script&lang=js"
export * from "./KusDemoForm.vue?vue&type=script&lang=js"
import style0 from "./KusDemoForm.vue?vue&type=style&index=0&id=3764f28f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports